const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d)(?=.*[^A-Za-z0-9_]).{8,}$/;

export default values => {
  const errors = {};

  if (!values.password && !values.confirmPassword) {
    return errors;
  }

  if (!values.password) {
    errors.password = 'Required';
  } else if (!passwordRegex.test(values.password)) {
    errors.password = 'Password must be 8 characters long containing letters, numbers and at least one special character';
  }

  if (!values.confirmPassword) {
    errors.confirmPassword = 'Required';
  } else if (values.confirmPassword !== values.password) {
    errors.confirmPassword = 'Password mismatched';
  }

  return errors;
};
